import { Stack } from '@/design-system/stack/stack';
import { BarChart4 } from 'lucide-react';

export const EmptyStateCard = () => {
  return (
    <Stack space={4} align="center" justify="center" className="absolute inset-0 flex items-center justify-center p-4">
      <div className="h-10 w-10 rounded-lg bg-muted p-2">
        <BarChart4 />
      </div>

      <p className="text-center text-sm leading-5 font-normal text-muted-foreground">
        Returns show after you've deposited funds and started earning.
      </p>
    </Stack>
  );
};
